import userHelper from 'utils/user'

function setAdminClientHelperForCurrentUser({ state }) {
  let user = state.get('client.currentUser')
  if (user) {
    let helper = userHelper(user)
    state.set('client.helper.admin.current', {
      isAdmin: helper.isAdmin(),
      isBilles: helper.isBilles(),
      shared: user.currentClient.modules
        ? user.currentClient.modules.reduce((acc, module) => {
            if (module.shared) {
              acc = true
            }
            return acc
          }, false)
        : false
    })
  } else {
    state.set('client.helper.admin.current', {})
  }
}

export default setAdminClientHelperForCurrentUser



// WEBPACK FOOTER //
// ./src/modules/user/actions/setAdminClientHelperForCurrentUser.js